module.exports = __webpack_public_path__ + "media/images/lb/550-b9c7325d1f5aa80e06039b48a9a7d0e2.svg";